import React from "react";
import { SneakerForm } from "../Components/SneakerForm";

export const Edit = () => {
  return (
    <div>
      <h3 className="text-center">Edit Sneaker</h3>
      <br />
      <SneakerForm />
    </div>
  );
};
